import Index from '../components/QuestionOrder/Index';

let routes = {
    path: '/questionOrder',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {
            path: '/questionOrder',
            component: Index
        }
    ]
};

export default routes;


// WEBPACK FOOTER //
// ./src/router/questionOrder.js